<template>
  <div>
    <v-divider></v-divider>
    
    <!-- Division Role Sidebar -->
    <v-layout wrap fill-height v-if="userRole === 'division' ">
      <v-flex class="sidebar-slot">
        <AppSidebar :items="items" v-model="sideNav" />
      </v-flex>
      <v-flex class="main-content-flex">
        <v-layout wrap pb-0 mb-0>
          <v-flex xs12 sm12 md12 lg12 pb-0 mb-0>
            <AppHeader class="pb-0 mb-0" @toggle-nav="sideNav = !sideNav" />
          </v-flex>
          <v-flex xs12 pt-0 mt-0><v-divider class="pt-0 mt-0"></v-divider></v-flex>
          <v-flex xs12 sm12 md12 lg12 pl-0>
            <v-layout wrap justify-center :style="
                $route.name == 'dashboard'
                  ? 'background-color: #ffffff'
                  : 'background-color: #f6fff9'
              ">
              <v-flex xs12>
                <v-card min-height="100vh" :color="
                    $route.name == 'dashboard' ? 'transparent' : '#FFFFFF'
                  " flat>
                  <v-layout wrap justify-center>
                    <v-flex xs12>
                      <router-view :key="$route.fullPath"></router-view>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- Circle Role Sidebar -->
    <v-layout wrap fill-height v-else-if="userRole === 'circle'">
      <v-flex class="sidebar-slot">
        <AppSidebar :items="items1" v-model="sideNav" />
      </v-flex>
      <v-flex class="main-content-flex">
        <v-layout wrap pb-0 mb-0>
          <v-flex xs12 sm12 md12 lg12 pb-0 mb-0>
            <AppHeader class="pb-0 mb-0" @toggle-nav="sideNav = !sideNav" />
          </v-flex>
          <v-flex xs12 pt-0 mt-0><v-divider class="pt-0 mt-0"></v-divider></v-flex>
          <v-flex xs12 sm12 md12 lg12 pl-0>
            <v-layout wrap justify-center :style="
                $route.name == 'dashboard'
                  ? 'background-color: #ffffff'
                  : 'background-color: #f6fff9'
              ">
              <v-flex xs12>
                <v-card min-height="100vh" :color="
                    $route.name == 'dashboard' ? 'transparent' : '#FFFFFF'
                  " flat>
                  <v-layout wrap justify-center>
                    <v-flex xs12>
                      <router-view :key="$route.fullPath"></router-view>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- Range Role Sidebar -->
    <v-layout wrap fill-height v-else-if="userRole === 'range'">
      <v-flex class="sidebar-slot">
        <AppSidebar :items="items2" v-model="sideNav" />
      </v-flex>
      <v-flex class="main-content-flex">
        <v-layout wrap pb-0 mb-0>
          <v-flex xs12 sm12 md12 lg12 pb-0 mb-0>
            <AppHeader class="pb-0 mb-0" @toggle-nav="sideNav = !sideNav" />
          </v-flex>
          <v-flex xs12 pt-0 mt-0><v-divider class="pt-0 mt-0"></v-divider></v-flex>
          <v-flex xs12 sm12 md12 lg12 pl-0>
            <v-layout wrap justify-center :style="
                $route.name == 'dashboard'
                  ? 'background-color: #ffffff'
                  : 'background-color: #f6fff9'
              ">
              <v-flex xs12>
                <v-card min-height="100vh" :color="
                    $route.name == 'dashboard' ? 'transparent' : '#FFFFFF'
                  " flat>
                  <v-layout wrap justify-center>
                    <v-flex xs12>
                      <router-view :key="$route.fullPath"></router-view>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- Fallback / General Officer Role Layout -->
    <v-layout wrap fill-height v-else>
      <v-flex class="sidebar-slot">
        <AppSidebar :items="items" v-model="sideNav" />
      </v-flex>
      <v-flex class="main-content-flex">
        <v-layout wrap pb-0 mb-0>
          <v-flex xs12 sm12 md12 lg12 pb-0 mb-0>
            <AppHeader class="pb-0 mb-0" @toggle-nav="sideNav = !sideNav" />
          </v-flex>
          <v-flex xs12 pt-0 mt-0><v-divider class="pt-0 mt-0"></v-divider></v-flex>
          <v-flex xs12 sm12 md12 lg12 pl-0>
            <v-layout wrap justify-center :style="$route.name == 'dashboard' ? 'background-color: #ffffff' : 'background-color: #f6fff9'">
              <v-flex xs12>
                <v-card min-height="100vh" :color="$route.name == 'dashboard' ? 'transparent' : '#FFFFFF'" flat>
                  <v-layout wrap justify-center>
                    <v-flex xs12>
                      <router-view :key="$route.fullPath"></router-view>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

  </div>
</template>
<script>
import AppHeader from "@/components/Common/appHeadersarpa";
import AppSidebar from "@/components/Common/appSidebar";

export default {
  components: {
    AppHeader,
    AppSidebar,
  },
  data() {
    return {
      //open state for the sidebar; only used below md, where it overlays
      sideNav: false,
      items: [
      {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/officers/sarpadashboard",
        },
        {
          title: "New Rescuers",
          icon: "mdi-account-plus",
          path: "/officers/newrescuerslist",
        },
        {
          title: "Rescuer List",
          icon: "mdi-account-multiple-plus ",
          path: "/officers/allrescuerlistOfficers",
        },
        {
          title: "DMO List",
          icon: "mdi-doctor",
          path: "/officers/alldmolist",
        },
        // {
        //   title: "Pending Operations",
        //   icon: "mdi-playlist-remove",
        //   path: "/officers/pendingoperations",
        // },
        // {
        //   title: "Assigned Operations",
        //   icon: "mdi-view-list",
        //   path: "/officers/assignedoperations",
        // },
        // {
        //   title: "Rescued Operations",
        //   icon: "mdi-playlist-plus",
        //   path: "/officers/rescuedoperations",
        // },
        // {
        //   title: "Released Operations",
        //   icon: "mdi-format-list-checks",
        //   path: "/officers/releasedoperations",
        // },
        // {
        //   title: "Approved Operations",
        //   icon: "mdi-playlist-check",
        //   path: "/officers/approvedoperations",
        // },
        {
          title: "Snake Reports",
          icon: "mdi-file-chart",
          path: "/officers/snakereports",
        },
        {
          title: "Delete Operations",
          icon: "mdi-delete-sweep",
          path: "/officers/deleteoperations",
        },
        {
          title: "Control Room ",
          icon: "mdi-file-account",
          path: "/officers/controlRoomList",
        },
        {
          title: "Emergency Officers",
          icon: "mdi-account-hard-hat",
          path: "/officers/alldistrictlist",
        },
        {
          title: "Snake Bite Cases",
          icon: "mdi-hospital-box-outline",
          path: "/officers/snakeBiteOfficers",
        },
        // {
        //   title: "Fraud Cases",
        //   icon: "mdi-close-box-multiple",
        //   path: "/officers/fraudcases",
        // },
        {
          title: "Reports",
          icon: "mdi-file-excel",
          path: "/officers/excelreport",
        },

      ],



      items1: [
      {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/officers/sarpadashboard",
        },
        {
          title: "New Rescuers",
          icon: "mdi-account-plus",
          path: "/officers/newrescuerslist",
        },
        {
          title: "Rescuer List",
          icon: "mdi-account-multiple-plus ",
          path: "/officers/allrescuerlistOfficers",
        },

         {
          title: "Training List",
          icon: "mdi-file-account",
          path: "/officers/officetraininglist",
        },


        {
          title: "DMO List",
          icon: "mdi-doctor",
          path: "/officers/alldmolist",
        },
        // {
        //   title: "Pending Operations",
        //   icon: "mdi-playlist-remove",
        //   path: "/officers/pendingoperations",
        // },
        // {
        //   title: "Assigned Operations",
        //   icon: "mdi-view-list",
        //   path: "/officers/assignedoperations",
        // },
        // {
        //   title: "Rescued Operations",
        //   icon: "mdi-playlist-plus",
        //   path: "/officers/rescuedoperations",
        // },
        // {
        //   title: "Released Operations",
        //   icon: "mdi-format-list-checks",
        //   path: "/officers/releasedoperations",
        // },
        // {
        //   title: "Approved Operations",
        //   icon: "mdi-playlist-check",
        //   path: "/officers/approvedoperations",
        // },
        {
          title: "Snake Reports",
          icon: "mdi-file-chart",
          path: "/officers/snakereports",
        },
        {
          title: "Delete Operations",
          icon: "mdi-delete-sweep",
          path: "/officers/deleteoperations",
        },
        {
          title: "Control Room ",
          icon: "mdi-file-account",
          path: "/officers/controlRoomList",
        },
        {
          title: "Emergency Officers",
          icon: "mdi-account-hard-hat",
          path: "/officers/alldistrictlist",
        },
        {
          title: "Snake Bite Cases",
          icon: "mdi-hospital-box-outline",
          path: "/officers/snakeBiteOfficers",
        },
        // {
        //   title: "Fraud Cases",
        //   icon: "mdi-close-box-multiple",
        //   path: "/officers/fraudcases",
        // },
        {
          title: "Reports",
          icon: "mdi-file-excel",
          path: "/officers/excelreport",
        },

      ],

      items2: [
      {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/officers/sarpadashboard",
        },
        {
          title: "New Rescuers",
          icon: "mdi-account-plus",
          path: "/officers/newrescuerslist",
        },
        {
          title: "Rescuer List",
          icon: "mdi-account-multiple-plus ",
          path: "/officers/allrescuerlistOfficers",
        },
        {
          title: "DMO List",
          icon: "mdi-doctor",
          path: "/officers/alldmolist",
        },
        // {
        //   title: "Pending Operations",
        //   icon: "mdi-playlist-remove",
        //   path: "/officers/pendingoperations",
        // },
        // {
        //   title: "Assigned Operations",
        //   icon: "mdi-view-list",
        //   path: "/officers/assignedoperations",
        // },
        // {
        //   title: "Rescued Operations",
        //   icon: "mdi-playlist-plus",
        //   path: "/officers/rescuedoperations",
        // },
        // {
        //   title: "Released Operations",
        //   icon: "mdi-format-list-checks",
        //   path: "/officers/releasedoperations",
        // },
        // {
        //   title: "Approved Operations",
        //   icon: "mdi-playlist-check",
        //   path: "/officers/approvedoperations",
        // },
        {
          title: "Snake Reports",
          icon: "mdi-file-chart",
          path: "/officers/snakereports",
        },
        {
          title: "Delete Operations",
          icon: "mdi-delete-sweep",
          path: "/officers/deleteoperations",
        },
        {
          title: "Emergency Officers",
          icon: "mdi-account-hard-hat",
          path: "/officers/alldistrictlist",
        },
        {
          title: "Control Room ",
          icon: "mdi-file-account",
          path: "/officers/controlRoomList",
        },
        // {
        //   title: "Training List",
        //   icon: "mdi-file-account",
        //   path: "/officers/traininglist",
        // },
        {
          title: "Snake Bite Cases",
          icon: "mdi-hospital-box-outline",
          path: "/officers/snakeBiteOfficers",
        },
        // {
        //   title: "Fraud Cases",
        //   icon: "mdi-close-box-multiple",
        //   path: "/officers/fraudcases",
        // },
        {
          title: "Reports",
          icon: "mdi-file-excel",
          path: "/officers/excelreport",
        },
        

      ],
      right: null,
    };
  },
  computed: {
  
   
    userRole() {
      return this.$store.state.userRole;
    },
  },
};
</script>

<style scoped>
/* reserves the column the fixed sidebar occupies from md up */
.sidebar-slot {
  flex: 0 0 0 !important;
  max-width: 0 !important;
  width: 0 !important;
}
@media (min-width: 960px) {
  .sidebar-slot {
    flex: 0 0 280px !important;
    max-width: 280px !important;
    width: 280px !important;
  }
}

.main-content-flex {
  flex: 1 1 auto !important;
  max-width: 100% !important;
  width: 100% !important;
}

@media (min-width: 960px) {
  .main-content-flex {
    max-width: calc(100% - 280px) !important;
    width: calc(100% - 280px) !important;
  }
}
</style>